<template>
  <div class="room-group-video-film-header">
    <div class="title-wrap">
      <div class="title">{{ getRoomGroupName(roomGroup.roomGroupId) }}</div>
    </div>
    <div class="btn-wrap">
      <template v-if="hasEmceeRole()">
        <button class="room-group-control-button mic"
              :data-device-status="micStatus"
              @click="onChangeRoomGroupMicMuteState"
        >
        </button>
        <button class="room-group-control-button speaker"
                :data-device-status="speakerStatus"
                @click="onChangeRoomGroupSpeakerMuteState"
        >
        </button>
        <button class="room-group-control-button layout"
                @click="()=>this.showRoomGroupLayout=!this.showRoomGroupLayout"
        >
        </button>
      </template>
      <button class="room-group-control-button hide-header"
              @click="() => this.$emit('close')"
      >
      </button>
    </div>
    <div class="room-group-layout" v-show="showRoomGroupLayout">
      <ul class="room-group-layout-list">
        <li class="room-group-layout-item"
            v-for="layout in layoutList"
            :key="layout"
            @click="onChangeRoomGroupLayoutType(layout)"
        >
          <button class="room-group-layout-button"
                  :data-layout="layout"
                  :class="{ selected: layout === (videoLayout || roomGroupLayout) }"
                  :style="layoutStyle(layout)"
          ></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import _ from "lodash";

export default {
  name: 'RoomGroupVideoFilmHeader',
  props: [
    'roomGroup'
  ],
  data() {
      return {
        showRoomGroupLayout: false,
        roomGroupLayout: '',
        layoutList: [
          'auto', 'ml_01_00', 'ml_02_00', 'ml_03_00', 'ml_04_00',
          'ml_05_00', 'ml_06_00', 'ml_07_00', 'ml_08_00', 'ml_09_00',
          'ml_10_00', 'ml_11_00', 'ml_12_00', 'ml_13_00', 'ml_16_00',
          'ml_17_00', 'ml_19_00', 'ml_20_00', 'ml_22_00', 'ml_25_00',
          'ml_30_00', 'ml_33_00', 'ml_36_00', 'ml_40_00', 'ml_43_00',
          'ml_46_00', 'ml_49_00', 'ml_49_01', 'ml_56_00', 'ml_58_00',
          'ml_61_00', 'ml_64_00', 'ml_81_00', 'ml_100_00'
        ]
      }
  },
  watch: {
    showRoomGroupLayout(val){
      if(val) {
        let roomGroupInfo = this.roomCall.mixingLayoutData.roomGroupDataMap[this.roomGroup.roomGroupId]
        this.roomGroupLayout = roomGroupInfo.layoutType
      }
    }
  },
  computed: {
    ...mapGetters('user', [
      'me',
      'hasEmceeRole',
      'isObserverRole',
      'isParticipantRole'
    ]),
    ...mapGetters('call', ['roomCall']),
    ...mapGetters('roomGroup', [
      'getRoomGroup',
      'getRoomGroupName',
      'roomGroupMicMuteState',
      'roomGroupSpeakerMuteState'
    ]),
    layoutStyle() {
      return (layoutType) => {
        return {
          '--background-ann': `url(${require(`@/assets/images/layout/old/${layoutType}.jpg`)}) no-repeat center / cover`,
          '--background-ann-hover': `url(${require(`@/assets/images/layout/old/${layoutType}_over.jpg`)}) no-repeat center / cover`
        }
      }
    },
    micStatus() {
      const micMuteState = this.roomGroupMicMuteState(this.roomGroup.roomGroupId)
      return micMuteState ? 'off' : 'on';
    },
    speakerStatus() {
      const speakerMuteState = this.roomGroupSpeakerMuteState(this.roomGroup.roomGroupId)
      return speakerMuteState ? 'off' : 'on';
    },
    roomGroupInfo() {
      return this.getRoomGroup(this.roomGroup.roomGroupId);
    },
    videoLayout() {
      const roomGroup =  this.getRoomGroup(this.roomGroup.roomGroupId);
      return roomGroup && roomGroup.videoLayout
    },
    speakerMuteState() {
      return this.roomGroupInfo.speakerMuteState || this.roomGroupInfo.speakerMuteState === undefined;
    }
  },
  methods: {
    ...mapActions('call', [
       'changeVideoLayout'
      ]),
    ...mapActions('roomGroup', [
      'setRoomUserGroup',
      'changeRoomGroupMicMuteState',
      'changeRoomGroupSpeakerMuteState',
    ]),
    ...mapActions('common', [
      'errorMessage',
    ]),

    async handleClickJoinGroup(roomGroup) {
      if (!this.hasEmceeRole() || this.me.roomGroupId === roomGroup.roomGroupId) {
        return;
      }

      try {
        await this.setRoomUserGroup({
          userId: this.me.userId,
          roomGroupId: roomGroup.roomGroupId
        });
      } catch(error) {
        this.errorMessage({ message: this.$t('group.video.error.enterFail'), error });
      }
    },
    onChangeRoomGroupMicMuteState() {
      this.changeRoomGroupMicMuteState({
        roomGroupId: this.roomGroup.roomGroupId,
        mute: this.micStatus === 'on'
      })
    },
    onChangeRoomGroupSpeakerMuteState() {
      this.changeRoomGroupSpeakerMuteState({
        roomGroupId: this.roomGroup.roomGroupId,
        mute: this.speakerStatus === 'on'
      })
    },
    onChangeRoomGroupLayoutType(layoutType) {
      if(!this.hasEmceeRole()){
        return;
      }
      if(!layoutType || this.roomGroupLayout === layoutType) {
        return;
      }
      if(!this._changeVideoLayout){
        this._changeVideoLayout = _.debounce((layoutType)=>{
          this.changeVideoLayout({layoutType, roomGroupId: this.roomGroup.roomGroupId})
        }, 500, {
          leading: true
        })
      }
      this._changeVideoLayout(layoutType);

      this.showRoomGroupLayout=!this.showRoomGroupLayout
    }
  }
}
</script>

<style lang="scss" scoped>
.room-group-video-film-header {
  width: 100%;
  height: 36px;
  padding: 0 10px;
  background: linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0));
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  transition: 0.2s ease-in-out;
}

.title-wrap {
  display: flex;
}

.title {
  font-size: 14px;
  font-weight: bold;
  color: white;
}

.btn-wrap {
  height: 100%;
  display: flex;
  align-items: center;
}
.room-group-control-button {
  width: 30px;
  height: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  transition: 0.1s ease-out;
  opacity: 0.7;

  &::before {
    content: '';
    width: 20px;
    height: 100%;
    display: block;
    pointer-events: none;
  }

  $devices: mic, speaker;
  @each $device in $devices {
    &.#{$device} {
      &[data-device-status="on"] {
        &::before {
          background: url('~@/assets/images/#{$device}_on_white.svg') no-repeat center / 75% auto;
        }
      }
      &[data-device-status="off"] {
        &::before {
          background: url('~@/assets/images/#{$device}_off_red.svg') no-repeat center / 75% auto;
        }
      }
    }
  }

  &.layout {
    &::before {
      background: url('~@/assets/images/layout_white.svg') no-repeat center / 75% auto;
    }
  }
  &.hide-header {
    &::before {
      background: url('~@/assets/images/arrowLineDown_white.svg') no-repeat center / 75% auto;
    }
  }
  &:hover {
    opacity: 1;
  }
}
.room-group-layout {
  border-radius: 6px;
  padding: 4px;
  background-color: #000;
  position: absolute;
  top: 40px;
  right: 0;
  z-index: 2;
}
.room-group-layout-list {
  display: grid;
  gap: 4px;
  grid-template-columns: repeat(5, 1fr);

}
.room-group-layout-item {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 45px;
  margin: 2px;
}
.room-group-layout-button {
  width: 100%;
  padding-bottom: 73.68421%;
  background: var(--background-ann);
  &:hover, &.selected {
    background: var(--background-ann-hover);
  }
}
[grm-device-mobile]{
  .room-group-video-film-header{
    display: none;
  }
}
</style>